import React, { FC } from 'react';
import { ConfigProvider, Input as AntdInput, InputProps as AntdInputProps } from 'antd';

interface InputProps extends AntdInputProps {
    type?: 'text' | 'password';
    label?: string;
    wrapperClassName?: string;
}

export const Input: FC<InputProps> = (props) => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#205BFC',
                    colorPrimaryText: '#FFFFFF',
                    colorBorder: '#A6BDFE',
                    paddingContentVertical: 0,
                },
            }}
        >
            <div className={`flex flex-col w-full ${props.wrapperClassName ? props.wrapperClassName : ''}`}>
                {props.label && (
                    <label className="font-bold text-base text-black-100 mb-2 max-lg:text-sm">{props.label}</label>
                )}
                {props.type === 'password' ? (
                    <AntdInput.Password
                        {...props}
                        className={`border border-primary-20 rounded-[28px] text-base px-6 h-14 max-lg:h-12 disabled:bg-white disabled:text-black-80 max-lg:text-sm ${props.className ? props.className : ''}`}
                    />
                ) : (
                    <AntdInput
                        {...props}
                        className={`border border-primary-20 rounded-[28px] text-base px-6 h-14 max-lg:h-12 disabled:bg-white disabled:text-black-80 max-lg:text-sm ${props.className ? props.className : ''}`}
                    />
                )}
            </div>
        </ConfigProvider>
    );
};
